import { captureException } from "@sentry/react";
import { toastApi } from "@shared/libs/toasts";

const MAX_DURATION_IN_MS = 3000;
let lastDisplayedErrorTime: number | null = null;

export const manageTooManyRequestError = (): void => {
  if (lastDisplayedErrorTime != null && Date.now() - lastDisplayedErrorTime < MAX_DURATION_IN_MS) {
    return;
  }

  lastDisplayedErrorTime = Date.now();

  toastApi.add({
    variant: "error",
    title: "Limite de requêtes atteinte",
    message: "Vous avez atteint la limite de requêtes autorisées. Veuillez réessayer plus tard.",
    duration: MAX_DURATION_IN_MS,
  });
  captureException(new Error("Too many requests made to the API"), {
    fingerprint: ["api-too-many-requests-429"],
  });
};
